import { JWT_SECRETKEY } from "commons/constants";
import crypto from "crypto-js";

export const resultQuestions = (data: any[]) => {
	return data.map((item: any) => ({
		category: item.category?.trim(),
		question: item.question?.trim(),
		isRequired: item.isRequired?.trim() === "Có" ? true : false,
		answer: item.answer?.trim() || "-",
		type: item.type?.trim(),
	}));
};

export const getLanguageId = (name: string) => {
	const languages = [
		{
			id: 1,
			name: "Tiếng Việt",
		},
		{
			id: 2,
			name: "Tiếng Anh",
		},
		{
			id: 3,
			name: "Tiếng Lào",
		},
		{
			id: 4,
			name: "Tiếng Myanmar",
		},
		{
			id: 5,
			name: "Tiếng Campuchia",
		},
	];

	const find = languages.find((language) => language.name.toLowerCase().trim() === name.toLowerCase().trim());

	if (!find) return 1;

	return find.id;
};

export const resultUsers = (data: any[]) => {
	return data.map((item: any) => {
		if (item.email) {
			return {
				id: item.userId.toString().trim(),
				name: item.name.trim(),
				email: item.email.trim() || null,
				languageId: getLanguageId(item.language.trim()),
			};
		}

		return {
			id: item.userId.toString().trim(),
			name: item.name.trim(),
			languageId: getLanguageId(item.language.trim()),
		};
	});
};

// export const decrypt = (str: string) => {
// 	const bytes = crypto.AES.decrypt(str, JWT_SECRETKEY);
// 	return JSON.parse(bytes.toString(crypto.enc.Utf8));
// };

// export const encrypt = (data: any) => {
// 	return crypto.AES.encrypt(JSON.stringify(data), JWT_SECRETKEY).toString();
// };

export const decrypt = (str: string) => {
	const bytes = crypto.AES.decrypt(decodeURIComponent(atob(str)), JWT_SECRETKEY);
	return JSON.parse(bytes.toString(crypto.enc.Utf8));
};

export const encrypt = (data: any) => {
	const str = crypto.AES.encrypt(JSON.stringify(data), JWT_SECRETKEY).toString();
	return encodeURIComponent(btoa(str)).replace("%3D%3D", "==");
};

export const stringToSlug = (str: string) => {
	var from = "àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ",
		to = "aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy";
	for (var i = 0, l = from.length; i < l; i++) {
		str = str.replace(RegExp(from[i], "gi"), to[i]);
	}

	str = str
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9\-]/g, "-")
		.replace(/-+/g, "-");

	return str;
};

export const handleSelectFilter = (input: string, { label }: any) => {
	return stringToSlug(label).indexOf(stringToSlug(input)) >= 0;
};
